import React from 'react'
import { ProgressComponent } from './ProgressComponent'


export const LoaderProgressBar = ({ progressDone }) => {
    return (

        <div className='progressLoader'>
            <ProgressComponent progressDone={progressDone} />
        </div>
    )
}
